export default "__VITE_ASSET__BL7R69rh__"